import { createTheme, Theme } from '@material-ui/core';
import deepmerge from 'deepmerge';
import { ThemeOptions } from '@material-ui/core/styles/createTheme';
import createPalette, { PaletteOptions, Palette } from '@material-ui/core/styles/createPalette';

//declare interface LayoutButtonOptions {
//    display?: React.CSSProperties['display'];
//    iconColor?: React.CSSProperties['color'];
//}
//declare module '@material-ui/core/styles/createTheme' {
//    // https://material-ui.com/guides/typescript/#customization-of-theme
//    interface Theme {
//        settingsMenu?: LayoutButtonOptions;
//        topMenu?: LayoutButtonOptions;
//    }
//    interface ThemeOptions {
//        settingsMenu?: LayoutButtonOptions;
//        topMenu?: LayoutButtonOptions;
//    }
//}

const basicPaletteOptions: PaletteOptions = {
    primary: {
        main: '#00838f'
    },
    secondary: {
        main: '#37474f'
    },
    background: {
        default: '#f5f5f5',
        paper: '#ffffff'
    },
    error: {
        main: '#c2185b'
    },
    common: {
        black: '#212b36',
        white: '#ffffff'
    },
    divider: '#61c3d0'
};

const createBasicThemeOptions = (palette: Palette): ThemeOptions => ({
    typography: {
        fontFamily: ['Montserrat', 'sans-serif'].join(', ')
    },
    palette,
    overrides: {
        MuiButton: {
            text: {
                padding: '0.5rem 1rem'
            },
            outlined: {
                borderColor: palette.primary.main,
                color: palette.primary.main,
                '&:hover': {
                    backgroundColor: 'rgba(0, 131, 143, 0.1)'
                },
                '&:disabled': {
                    borderColor: 'transparent'
                },
                boxShadow: 'none',
                padding: '0.5rem 1rem'
            },
            outlinedSecondary: {
                borderColor: palette.secondary.main,
                color: palette.secondary.main
            },
            contained: {
                backgroundColor: palette.primary.main,
                color: palette.common.white,
                '&:hover': {
                    backgroundColor: 'rgba(0, 131, 143, 0.8)'
                },
                '&:disabled': {
                    backgroundColor: '#eee'
                },
                boxShadow: 'none',
                padding: '0.5rem 1rem'
            },
            containedSecondary: {
                backgroundColor: palette.secondary.main
            }
        },
        MuiTextField: {
            root: {
                '@media screen and (min-width: 960px)': {
                    minWidth: '328px'
                },
                margin: '0px',
                '& > div': {
                    borderRadius: '2px',
                    height: '48px'
                }
            }
        },
        MuiAppBar: {
            root: {
                boxShadow: 'none'
            }
        },
        MuiCard: {
            root: {
                boxShadow: 'none',
                borderRadius: '2px'
            }
        },
        MuiCardHeader: {
            title: {
                fontWeight: 'bolder',
                fontSize: '1rem'
            }
        },
        MuiTableCell: {
            root: {
                fontFamily: ['Lato', 'sans-serif'].join(', ')
            },
            head: {
                fontSize: '1rem'
            },
            body: {
                fontSize: '1rem'
            }
        }
    }
});

export const createCustomTheme = (customThemeOptions?: ThemeOptions): Theme => {
    const mergedPaletteOptions = customThemeOptions && customThemeOptions.palette ? deepmerge(basicPaletteOptions, customThemeOptions.palette) : basicPaletteOptions;

    const palette = createPalette(mergedPaletteOptions);

    const basicThemeOptions = createBasicThemeOptions(palette);

    const mergedOptions: ThemeOptions = customThemeOptions ? deepmerge(basicThemeOptions, customThemeOptions) : basicThemeOptions;
    return createTheme(mergedOptions);
};
